import { TaskDirection } from '@admiin-com/ds-graphql';
import React, { useState } from 'react';
import { AutoCompleteDataType } from '../../components/AutoCompleteLookup/AutoCompleteLookupV2';
import { useFormContext, useWatch } from 'react-hook-form';
import { useDefaultValueForFromTo } from '../../features/providers/TaskCreationProvider/TaskCreationProvider';
import { useFirmId } from '../../hooks/useClientWorkflow/useClientWorkflow';
import { useTaskCreationContext } from '../../features/providers/TaskCreationProvider/useTaskCreationContext';

export const useFromToTypeFromTaskDirection = ({
  name = '',
}: {
  name?: string;
} = {}) => {
  const fieldName = name ? `${name}.` : '';
  const [fromType, setFromType] = useState<AutoCompleteDataType>('Entity');
  const [toType, setToType] = useState<AutoCompleteDataType>('Entity');
  const entity = useDefaultValueForFromTo();
  const { taskDirection, taskType, contact, client } = useTaskCreationContext();
  const { setValue, watch, control } = useFormContext();
  const [defaultFrom, setDefaultFrom] = React.useState<any>(null);
  const [defaultTo, setDefaultTo] = React.useState<any>(null);

  React.useEffect(() => {
    if (taskDirection === TaskDirection.SENDING) {
      if (entity) {
        setDefaultValueFromValue(entity);
      }
      if (contact || client) {
        setDefaultValueToValue(contact || client);
      }
    } else if (taskDirection === TaskDirection.RECEIVING) {
      if (contact || client) {
        setDefaultValueFromValue(contact || client);
      }
      if (entity) {
        setDefaultValueToValue(entity);
      }
    }
  }, [taskDirection, entity, contact, client]);

  const setDefaultValueToValue = (value: any) => {
    setDefaultTo(value);
    if (!watch(`${fieldName}to`) && value) {
      setValue(`${fieldName}to`, value, { shouldValidate: true });
    }
  };

  const setDefaultValueFromValue = (value: any) => {
    setDefaultFrom(value);
    if (!watch(`${fieldName}from`) && value) {
      setValue(`${fieldName}from`, value, { shouldValidate: true });
    }
  };
  const { firmId } = useFirmId();
  const isFromFirm =
    useWatch({ name: `${fieldName}from.id`, control }) === firmId;

  React.useEffect(() => {
    switch (taskDirection) {
      case TaskDirection.SENDING:
        setFromType('Entity');
        setToType('Contact');
        break;
      case TaskDirection.RECEIVING:
        setFromType('ContactsAndVerifiedEntity');
        setToType('Entity');
        break;
    }

    if (taskDirection === TaskDirection.SENDING) {
      if (isFromFirm) {
        setToType('ClientContacts');
      } else {
        setToType('Contact');
      }
    }
  }, [taskDirection, taskType, isFromFirm]);

  return {
    fromType,
    toType,
    setToType,
    setFromType,
    defaultFrom,
    defaultTo,
    isFromFirm,
  };
};
